import styled, { css } from 'styled-components';

export const VariantItem = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    gap: ${theme.sz.s1};
    min-width: 0;
    padding: 0;
    flex-shrink: 0;
  `,
);

export const VariantOr = styled.span(
  ({ theme }) => css`
    color: ${theme.co.neutral40};
    font-size: 0.9em;
    flex-shrink: 0;
  `,
);

export const Variants = styled.div<{ $multi?: boolean }>(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${theme.sz.s2} ${theme.sz.s3};
    min-width: 0;
    vertical-align: middle;
    margin-top: ${theme.sz.s2};
  `,
);

export const Diagram = styled.span(
  () => css`
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    gap: 0.2em;
  `,
);

export const DiagramSvg = styled.svg(
  () => css`
    width: auto;
    height: 48px;
    display: block;
  `,
);

export const MoraLabel = styled.text(
  () => css`
    font-family:
      'Hiragino Sans', 'Hiragino Kaku Gothic ProN', 'Noto Sans CJK JP', 'Yu Gothic', sans-serif;
  `,
);
